module.exports = __webpack_public_path__ + "static/media/Duan1.619ff391.png";